const HANDOFF_KEY = "ni-portfolio-handoff";

let claimedHandoff: string | null = null;

/** Marks the next review screen as a live upload, not a refreshed history entry. */
export function beginPortfolioHandoff(): string {
  const token = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  sessionStorage.setItem(HANDOFF_KEY, token);
  claimedHandoff = null;
  return token;
}

/**
 * True only for the navigation that just parsed a file.
 * A refresh restores history.state but not this one-time token.
 */
export function claimPortfolioHandoff(token: unknown): boolean {
  if (typeof token !== "string" || token.length === 0) return false;
  if (claimedHandoff === token) return true;
  if (sessionStorage.getItem(HANDOFF_KEY) !== token) return false;
  sessionStorage.removeItem(HANDOFF_KEY);
  claimedHandoff = token;
  return true;
}

export function clearPortfolioHandoff(): void {
  claimedHandoff = null;
  sessionStorage.removeItem(HANDOFF_KEY);
}
